import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStudent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 1a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3m7 5v6h-2v-3H3v3H1v-6z"
	})
});
export default SvgStudent;
